import { BehaviorParameters } from 'rangeConfig/@types';
import { ComponentIds } from '@inter-ikea-core/core';

const removeAllHandlesOnSelectedFrame = ({ coreApi }: BehaviorParameters) => {
  const frame = coreApi.entities.findSelectedEntity();

  if (frame) {
    const handles = coreApi.entities
      .getFrameDescendants(frame)
      .filter(child => child.hasComponent(ComponentIds.HANDLE_COMPONENT_ID));
    if (handles.length > 0) {
      coreApi.entities.deleteMultiple(handles);
    }
  }
};

export default removeAllHandlesOnSelectedFrame;
